
/**
 * @xq lumina广告使用手册
 * @xq https://docs.corp.kuaishou.com/k/home/VDT7vcvO6788/fcACjsYkrrsXmYGMgbTAl19i2#section=h.q18im69xu5wa
 */
import { defineComponent, onMounted, getCurrentInstance, SetupContext, watch, ref, onUnmounted } from 'vue';
import { sendLog } from '@/common/radar';
// eslint-disable-next-line import/no-extraneous-dependencies

const LuminaAD = defineComponent({
    props: {
        index: {
            type: Number,
            default: 0,
        },
    },
    emits: ['onLuminaAdLoadFailed'],
    setup(props, ctx: SetupContext<Array<'onLuminaAdLoadFailed'>>) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const lumina_index = `adsbyluminaid-${props.index}`;
        const isMuted = ref(proxy?.$store?.state?.feedMoudle?.isMuted ? 'true' : 'false');
        const isMutedBtnHidden = ref(!proxy?.$store?.state?.feedMoudle?.isMuted);
        const adRef = ref<HTMLElement>();
        const adObserver = ref<IntersectionObserver>();
        watch(
            () => proxy?.$store?.state?.feedMoudle?.isMuted,
            (newVal: any) => {
                console.log('lumina-ad', 'mute change', newVal);
                isMuted.value = newVal ? 'true' : 'false';
                isMutedBtnHidden.value = !newVal;
            }
        );

        const createIntersectionObserver = () => {
            adObserver.value = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        const top = entry.boundingClientRect.top;
                        if (entry.isIntersecting && top > 0 && entry.intersectionRatio > 0.8) {
                            // 组件出现在屏幕上
                            console.log('lumina-ad', 'ad show up');
                            handleShowAd();
                        }
                    });
                },
                { threshold: 0.8 }
            );

            adRef.value && adObserver.value.observe(adRef.value);
        };

        const handleClickAd = (isSlot: boolean) => {
            sendLog({
                type: 'click',
                name: 'ADSENSE',
                value: {
                    type: isSlot ? 'action' : 'full',
                },
            });
        };
        const handleShowAd = () => {
            sendLog({
                type: 'show',
                name: 'ADSENSE',
                value: {
                    type: 'lumina_ad',
                },
            });
        };
        const adsbylumina = ref(null);
        onMounted(async () => {
            // eslint-disable-next-line import/no-extraneous-dependencies
            const countryInfo = proxy?.store?.state?.startup?.countryInfo;
            await import('@i18n/kwai-i18n-ad-lumina-sdk');
            (adsbylumina.value = window.adsbylumina || []).push({
                luminaAdToken: lumina_index,
                adOptions: {
                    country: countryInfo || 'BRA',
                },
                onAdClick: () => {
                    console.log('lumina-ad', 'clicked');
                    handleClickAd(false);
                },
                onSlotReady: (slotClassName: string) => {
                    console.log('lumina-ad', 'slot ready');
                },
                onSlotClick: () => {
                    console.log('lumina-ad', 'slot click');
                    handleClickAd(true);
                },
                onMutedChange: (isMute: string) => {
                    console.log('lumina-ad', 'set mute', isMute);
                    proxy?.$store?.commit?.('feedMoudle/setMuted', isMute === 'true');
                },
            });
            const targetNode = document.getElementById(lumina_index) as Element;
            const config = {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: ['data-ad-status'],
            };

            const callback = function (mutationsList: any, observer: any) {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-ad-status') {
                        const data_ad_status = mutation.target.getAttribute('data-ad-status');
                        if (data_ad_status === 'unfilled') {
                            console.log('lumina-ad', 'delete ad', props.index + 1);
                            ctx.emit('onLuminaAdLoadFailed', props.index);
                        }
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);

            createIntersectionObserver();
        });
        onUnmounted(() => {
            adObserver.value?.disconnect?.();
        });
        return { lumina_index, isMuted, isMutedBtnHidden, adRef };
    },
});
export default LuminaAD;
